<template>
  <div class="moudule12">
    <div class="framer-ueu2pe" data-framer-name="5" name="5">
      <div class="framer-g1i885" data-framer-name="BG" name="BG">
        <div
          style="position:absolute;border-radius:inherit;top:0;right:0;bottom:0;left:0"
          data-framer-background-image-wrapper="true"
        >
          <img
            :src="moduleData.backgroundPicture"
            style="display:block;width:100%;height:100%;border-radius:inherit;object-position:center;object-fit:cover;image-rendering:auto"
            loading="lazy"
          />
        </div>
      </div>
      <a
        class="framer-dfez7x framer-lux5qc"
        style="transform: none;"
        @click="download(moduleData.fileUrl, moduleData.fileName)"
        ><div
          style="position:absolute;border-radius:inherit;top:0;right:0;bottom:0;left:0"
          data-framer-background-image-wrapper="true"
        >
          <img
            :src="moduleData.downloadIconUrl"
            alt=""
            sizes="269px"
            style="display:block;width:100%;height:100%;border-radius:inherit;object-position:center;object-fit:cover;image-rendering:auto"
            loading="lazy"
          /></div
      ></a>
    </div>
  </div>
</template>
<script>
export default {
  name: "file-download",
  props: {
    moduleData: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    download(fileUrl, fileName) {
      console.log(fileName);
      var xml = new XMLHttpRequest();
      xml.open("GET", fileUrl, true);
      xml.responseType = "blob";
      xml.onload = function() {
        var url = window.URL.createObjectURL(xml.response);
        var a = document.createElement("a");
        a.href = url;
        if (fileName) a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      };
      xml.send();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@style/base";
@import "@style/common";
.moudule12 {
  background: #f5f7fb;
}
.framer-ueu2pe {
  flex: none;
  height: 513px;
  overflow: hidden;
  position: relative;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
}
.framer-g1i885 {
  flex: none;
  height: 513px;
  left: calc(49.95196926032663% - 100% / 2);
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
}
.framer-dfez7x {
  aspect-ratio: 8.75 / 1;
  bottom: 80px;
  flex: none;
  height: var(--framer-aspect-ratio-supported, 48px);
  left: calc(49.7530864197531% - 420px / 2);
  position: absolute;
  text-decoration: none;
  transform: translate(-50%);
  width: 420px;
}
.framer-uthm47 {
  flex: none;
  height: 100px;
  overflow: hidden;
  position: relative;
  width: 100%;
}
@supports (background: -webkit-named-image(i)) and (not (scale: 1)) {
  .framer-72rtr7 {
    gap: 0px;
  }
  .framer-72rtr7 > * {
    margin: 0;
  }
  .framer-72rtr7 > :first-child {
    margin-top: 0;
  }
  .framer-72rtr7 > :last-child {
    margin-bottom: 0;
  }
}
@media (min-width: 1041px) {
  .hidden-72rtr7 {
    display: none !important;
  }
}
@media (min-width: 810px) and (max-width: 1040px) {
  .hidden-hfynm0 {
    display: none !important;
  }
  .framer-body-augiA20Il {
    background: white;
  }
  .framer-72rtr7,
  .framer-uthm47 {
    width: 810px;
  }
  .framer-1fzkg8f {
    height: 322px;
    width: 810px;
  }
  .framer-xmyv3q {
    background-color: #f5f7fb;
    height: 837px;
  }
  .framer-17cuqaw {
    bottom: unset;
    height: 837px;
    left: calc(50.00000000000002% - 810px / 2);
    top: calc(49.94026284348867% - 837px / 2);
    width: 810px;
  }
  .framer-e4kawp {
    height: 434px;
    width: 810px;
  }
  .framer-ueu2pe {
    background-color: #f5f7fb;
    height: 461px;
  }
  .framer-g1i885 {
    height: 461px;
    left: calc(49.95196926032663% - 810px / 2);
    width: 810px;
  }
  .framer-dfez7x {
    aspect-ratio: unset;
    bottom: 60px;
    height: 48px;
    left: calc(49.7530864197531% - 410px / 2);
    transform: unset;
    width: 410px;
  }
}
@media (max-width: 809px) {
  .hidden-10x6vsp {
    display: none !important;
  }
  .framer-body-augiA20Il {
    background: white;
  }
  .framer-72rtr7 {
    width: 375px;
  }
  .framer-16za8fu {
    height: 540px;
  }
  .framer-1fzkg8f {
    height: 254px;
    width: 375px;
  }
  .framer-xmyv3q {
    background-color: #f5f7fb;
    height: 666px;
  }
  .framer-17cuqaw {
    bottom: unset;
    height: 666px;
    left: calc(50.00000000000002% - 375px / 2);
    top: calc(49.94026284348867% - 666px / 2);
    width: 375px;
  }
  .framer-e4kawp {
    height: 445px;
    width: 375px;
  }
  .framer-ueu2pe {
    background-color: #f5f7fb;
    height: 301px;
  }
  .framer-g1i885 {
    height: 301px;
    left: calc(49.95196926032663% - 375px / 2);
    width: 375px;
  }
  .framer-dfez7x {
    aspect-ratio: unset;
    bottom: 40px;
    height: 30px;
    left: calc(49.60000000000002% - 269px / 2);
    transform: unset;
    width: 269px;
  }
  .framer-uthm47 {
    height: 166px;
    width: 375px;
  }
}
</style>
